import { useCallback, useState } from 'react';

import { useSelector } from 'react-redux';

import { selectHasSummarizationSettingsPermission } from '../../permissions';
import { selectIsSummarizationMailForParticipants } from '../selectors';

interface CheckboxState {
    isSelected: boolean;
    isDisabled: boolean;
}
type SettableCheckboxState = Partial<Pick<CheckboxState, 'isSelected'>>;

type SetCheckboxState = (state: SettableCheckboxState) => void;

export function useSummarizationMailRecipientCheckboxState(): [CheckboxState, SetCheckboxState] {
    const isSummarizationMailForParticipants = useSelector(selectIsSummarizationMailForParticipants);
    const hasSummarizationSettingsPermission = useSelector(selectHasSummarizationSettingsPermission);

    const [desiredIsSummarizationMailForParticipants, setDesiredIsSummarizationMailForParticipants] = useState(
        isSummarizationMailForParticipants
    );

    const state: CheckboxState = {
        isSelected: Boolean(desiredIsSummarizationMailForParticipants),
        isDisabled: !hasSummarizationSettingsPermission,
    };

    const setState = useCallback(({ isSelected }: { isSelected?: boolean } = {}) => {
        if (isSelected !== undefined) {
            setDesiredIsSummarizationMailForParticipants(isSelected);
        }
    }, []);

    return [state, setState];
}
